import { combineReducers } from 'redux';
const initialState = {
  metadata: {
    alertTypes: [],
    severity: [],
    isFetching: true,
    error: false,
    enterprise: { list: [], isFetching: true, error: false },
    developer: false,
    support: false,
    notificationsMigration: false,
    userAccessType: 'admin',
    reportType: { list: [], isFetching: true, error: false },
    cp: { list: [] },
    service: { list: [] },
    account: { list: [] },
    sampleTemplate: {
      list: [],
      file: {
        directory: 'sample_shipping_label/',
        bucketUrl: 'https://pyck-res-bucket.s3.amazonaws.com/'
      }
    }
  },
  alert: { list: [], totalPages: 0, isFetching: true, error: false, pageNo: 1 },
  statuses: {
    mapped: { list: [], isFetching: true, error: false },
    unmapped: { list: [], isFetching: true, error: false },
    newStatus: { success: null, isFetching: true, error: false }
  },
  config: { ssr: true, route: '/' },
  jobs: {
    isFetching: true,
    error: false,
    list: [],
    raw: [],
    sorting: { key: null, order: -1 },
    ec2: {
      isFetching: true,
      error: false,
      list: []
    }
  },
  activeReports: {
    enterprises: [],
    reportTypes: [],
    isFetching: true,
    error: false,
    reports: {
      isFetching: true,
      error: false,
      list: [],
      count: 0,
      pageNo: 1,
      isPaginationFetching: false
    }
  },
  shippingLabels: {
    isFetching: false,
    error: false,
    list: [],
    file: { directory: 'shipping_label/' },
    count: 0,
    pageNo: 1,
    isPaginationFetching: false
  },
  sampleTemplates: {
    isFetching: false,
    error: false,
    list: [],
    file: { directory: 'sample_shipping_label/' },
    count: 0,
    pageNo: 1,
    isPaginationFetching: false
  },
  emailTemplate: {
    isFetching: false,
    error: false,
    list: [],
    file: { directory: 'sample_email_template/' },
    count: 0,
    pageNo: 1,
    isPaginationFetching: false,
    notification: { list: [], isFetching: true }
  },
  shipmentLog: {
    isFetching: true,
    error: false,
    list: [],
    async: {
      html: '',
      url: '',
      request: {
        jobId: null
      },
      metadata: []
    }
  },
  billing: {
    isFetching: true,
    error: false,
    list: [],
    filter: {
      serviceType: [],
      months: [],
      billingType: [],
      ruleType: []
    },
    rule: {
      list: [],
      isFetching: true
    }
  },
  trackingDelay: {
    isFetching: true,
    error: false,
    list: [],
    legends: [],
    colors: [],
    percentile: {
      isFetching: true,
      error: false,
      list: [],
      legends: [],
      colors: []
    }
  },
  warehouse: {
    cities: [],
    isFetching: true,
    error: false,
    unmapped: []
  },
  orderCreation: {
    isFetching: true,
    error: false,
    list: [],
    legends: [],
    colors: [],
    lineKey: 'All'
  },
  featureEnvs: {
    isFetching: true,
    error: false,
    environments: {
      b2c: [
        {
          label: 'Production',
          link: 'https://dashboard-us.clickpost.ai',
          locked: true
        },
        {
          label: 'Staging',
          link: 'https://dashboard-v2.clickpost.in',
          locked: true
        }
      ],
      b2c_us: [
        {
          label: 'Production',
          link: 'https://app.clickpost.ai',
          locked: true
        },
        {
          label: 'Staging',
          link: 'https://app-staging.clickpost.ai',
          locked: true
        }
      ],
      b2b: [
        {
          label: 'Production',
          link: 'https://b2b.clickpost.ai',
          locked: true
        },
        {
          label: 'Staging',
          link: 'https://b2b-staging.clickpost.ai',
          locked: true
        }
      ],
      prism: [
        {
          label: 'Production',
          link: 'https://prism.clickpost.ai',
          locked: true
        },
        {
          label: 'Staging',
          link: 'https://marketplace-dashboard.myclickpost.com',
          locked: true
        }
      ],
      returnsPlus: [
        {
          label: 'Production-v1',
          link: 'https://admin.clickpost.ai',
          locked: true
        },
        {
          label: 'Production-v2',
          link: 'https://returns.clickpost.ai',
          locked: true
        },
        {
          label: 'Staging',
          link: 'https://admin-dev.clickpostapp.info',
          locked: true
        }
      ],
      trackingV2: [
        {
          label: 'Production',
          link: 'https://subdomain.domain.tld',
          locked: true
        }
      ]
    }
  }
};

const user = (state = {}, action) => {
  switch (action.type) {
    case 'CREATE_SESSION':
      return {
        ...state,
        ...action.session.user
      };
    default:
      return state;
  }
};

const metadata = (state = initialState.metadata, action) => {
  switch (action.type) {
    case 'ENTERPRISE_META_DATA_REQUEST':
    case 'SAMPLE_TEMPLATE_META_DATA_REQUEST':
    case 'CP_META_DATA_REQUEST':
    case 'USER_ACCESS_REQUEST':
      return state;
    case 'META_DATA_SUCCESS':
      return {
        ...state,
        ...action.data
      };
    case 'META_DATA_FAILURE':
      return {
        ...state,
        ...action.data
      };
    case 'ENTERPRISE_META_DATA_SUCCESS':
      return {
        ...state,
        enterprise: {
          ...state.enterprise,
          list: action.data.enterprises,
          isFetching: false,
          error: false
        },
        reportType: {
          ...state.reportType,
          list: action.data.reportTypes,
          isFetching: false,
          error: false
        }
      };
    case 'USER_ACCESS_SUCCESS':
      return {
        ...state,
        isFetching: false,
        enterprise: {
          ...state.enterprise,
          list: action.data.enterprises,
          isFetching: false,
          error: false
        },
        developer: action.data.developer,
        support: action.data.support,
        notificationsMigration: action.data.notificationsMigration || false,
        userAccessType: action.data.userAccessType || 'admin'
      };
    case 'USER_ACCESS_FAILURE':
      return {
        ...state,
        enterprise: {
          ...state.enterprise,
          list: [],
          isFetching: false,
          error: true
        }
      };
    case 'CP_META_DATA_SUCCESS':
      return {
        ...state,
        cp: {
          ...state.cp,
          list: action.data.list,
          isFetching: false,
          error: false
        },
        account: {
          ...state.account,
          list: action.data.accounts,
          isFetching: false,
          error: false
        }
      };
    case 'CP_META_DATA_RESET':
      return {
        ...state,
        cp: {
          ...state.cp,
          list: [],
          isFetching: false,
          error: false
        },
        account: {
          ...state.account,
          list: [],
          isFetching: false,
          error: false
        }
      };
    case 'SERVICE_META_DATA_SUCCESS':
      return {
        ...state,
        cp: {
          ...state.cp,
          list: action.data.cps
        },
        service: {
          ...state.service,
          list: action.data.services
        }
      };
    default:
      return state;
  }
};

const alert = (state = initialState.alert, action) => {
  switch (action.type) {
    case 'ALERT_REQUEST':
      return {
        ...state,
        ...action.data
      };
    case 'ALERT_SUCCESS':
    case 'ALERT_UPDATE':
      return {
        ...state,
        ...action.data
      };
    case 'ALERT_FAILURE':
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
};

const statuses = (state = initialState.statuses, action) => {
  switch (action.type) {
    case 'UNMAPPED_STATUS_REQUEST':
      return {
        ...state,
        unmapped: {
          ...state.unmapped,
          list: [],
          isFetching: true,
          error: false
        }
      };
    case 'MAPPED_STATUS_REQUEST':
    case 'NEW_STATUS_REQUEST':
      return {
        ...state,
        ...action.data
      };
    case 'MAPPED_STATUS_SUCCESS':
    case 'UNMAPPED_STATUS_SUCCESS':
    case 'NEW_STATUS_SUCCESS':
    case 'UNMAPPED_STATUS_UPDATE':
      return {
        ...state,
        ...action.data
      };
    case 'MAPPED_STATUS_FAILURE':
    case 'UNMAPPED_STATUS_FAILURE':
    case 'NEW_STATUS_FAILURE':
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
};

const config = (state = initialState.config, action) => {
  switch (action.type) {
    case 'CONFIG_REQUEST':
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
};

const jobs = (state = initialState.jobs, action) => {
  switch (action.type) {
    case 'JOBS_REQUEST':
      return {
        ...state
      };
    case 'JOBS_SUCCESS':
      return {
        ...state,
        ...action.data
      };
    case 'JOBS_FAILURE':
      return {
        ...state,
        ...action.data
      };
    case 'SORTING_JOBS':
      return {
        ...state,
        list: action.data
      };
    case 'SORTING_CHANGE':
      return {
        ...state,
        sorting: {
          ...action.data
        }
      };
    case 'EC2_MACHINE_REQUEST':
      return {
        ...state,
        ec2: {
          isFetching: true,
          error: false,
          list: []
        }
      };
    case 'EC2_MACHINE_SUCCESS':
      return {
        ...state,
        ec2: {
          isFetching: false,
          error: false,
          list: action.data
        }
      };
    case 'EC2_MACHINE_FAILURE':
      return {
        ...state,
        ec2: {
          isFetching: false,
          error: true,
          list: []
        }
      };
    default:
      return state;
  }
};

const activeReports = (state = initialState.activeReports, action) => {
  switch (action.type) {
    case 'ACTIVE_REPORTS_META_DATA_REQUEST':
      return {
        ...state
      };
    case 'ACTIVE_REPORTS_META_DATA_SUCCESS':
      return {
        ...state,
        ...action.data
      };
    case 'ACTIVE_REPORTS_META_DATA_FAILURE':
      return {
        ...state,
        ...action.data
      };
    case 'ACTIVE_REPORTS_REQUEST':
      return {
        ...state,
        reports: {
          ...state.reports,
          list: [],
          isFetching: true,
          error: false,
          pageNo: 1
        }
      };
    case 'ACTIVE_REPORTS_SUCCESS':
      return {
        ...state,
        reports: {
          ...state.reports,
          ...action.data
        }
      };
    case 'ACTIVE_REPORTS_FAILURE':
      return {
        ...state,
        reports: {
          ...state.reports,
          ...action.data
        }
      };
    case 'ACTIVE_REPORTS_PAGINATION_REQUEST':
      return {
        ...state,
        reports: {
          ...state.reports,
          isPaginationFetching: true
        }
      };
    case 'ACTIVE_REPORTS_PAGINATION_SUCCESS':
      return {
        ...state,
        reports: {
          ...state.reports,
          pageNo: state.reports.pageNo + 1,
          isPaginationFetching: false,
          ...action.data
        }
      };
    case 'ACTIVE_REPORTS_PAGINATION_FAILURE':
      return {
        ...state,
        reports: {
          ...state.reports,
          ...action.data
        }
      };
    default:
      return state;
  }
};

const shippingLabels = (state = initialState.shippingLabels, action) => {
  switch (action.type) {
    case 'SHIPPING_LABELS_RESET':
      return {
        ...state,
        isFetching: false,
        error: false,
        list: [],
        pageNo: 1
      };
    case 'SHIPPING_LABELS_REQUEST':
      return {
        ...state,
        isFetching: true,
        error: false,
        list: [],
        pageNo: 1
      };
    case 'SHIPPING_LABELS_SUCCESS':
      return {
        ...state,
        ...action.data
      };
    case 'SHIPPING_LABELS_PAGINATION_REQUEST':
      return {
        ...state,
        isPaginationFetching: true
      };
    case 'SHIPPING_LABELS_PAGINATION_SUCCESS':
      return {
        ...state,
        pageNo: state.pageNo + 1,
        isPaginationFetching: false,
        ...action.data
      };
    case 'SHIPPING_LABELS_PAGINATION_FAILURE':
      return {
        ...state,
        reports: {
          ...state.reports,
          ...action.data
        }
      };
    default:
      return state;
  }
};

const sampleTemplates = (state = initialState.sampleTemplates, action) => {
  switch (action.type) {
    case 'SAMPLE_TEMPLATES_REQUEST':
      return {
        ...state,
        isFetching: true,
        error: false,
        list: [],
        pageNo: 1
      };
    case 'SAMPLE_TEMPLATES_SUCCESS':
      return {
        ...state,
        isFetching: false,
        ...action.data
      };
    case 'SAMPLE_TEMPLATES_PAGINATION_REQUEST':
      return {
        ...state,
        isPaginationFetching: true
      };
    case 'SAMPLE_TEMPLATES_PAGINATION_SUCCESS':
      return {
        ...state,
        pageNo: state.pageNo + 1,
        isPaginationFetching: false,
        ...action.data
      };
    case 'SAMPLE_TEMPLATES_PAGINATION_FAILURE':
      return {
        ...state,
        reports: {
          ...state.reports,
          ...action.data
        }
      };
    default:
      return state;
  }
};

const emailTemplate = (state = initialState.emailTemplate, action) => {
  switch (action.type) {
    case 'EMAIL_TEMPLATE_METADATA_REQUEST':
      return {
        ...state,
        notification: {
          ...state.notification,
          isFetching: true,
          list: []
        }
      };
    case 'EMAIL_TEMPLATE_METADATA_SUCCESS':
      return {
        ...state,
        notification: {
          ...state.notification,
          isFetching: false,
          list: action.data
        }
      };
    case 'EMAIL_TEMPLATE_METADATA_FAILURE':
      return {
        ...state,
        notification: {
          ...state.notification,
          isFetching: false,
          list: action.data
        }
      };
    case 'EMAIL_TEMPLATE_REQUEST':
      return {
        ...state,
        isFetching: true,
        list: []
      };
    case 'EMAIL_TEMPLATE_SUCCESS':
      return {
        ...state,
        isFetching: false,
        list: action.data
      };
    case 'EMAIL_TEMPLATE_FAILURE':
      return {
        ...state,
        isFetching: false,
        isError: true,
        list: []
      };
    default:
      return state;
  }
};

const shipmentLog = (state = initialState.shipmentLog, action) => {
  switch (action.type) {
    case 'SHIPMENT_LOG_REQUEST':
    case 'SHIPMENT_LOG_RESET':
      return {
        ...state,
        list: [],
        isFetching: true,
        error: false
      };
    case 'SHIPMENT_LOG_SUCCESS':
      return {
        ...state,
        ...action.data,
        isFetching: false,
        error: false
      };
    case 'SHIPMENT_LOG_FAILURE':
      return {
        list: [],
        isFetching: false,
        error: true
      };
    case 'SHIPMENT_LOG_ASYNC_METADATA_REQUEST':
      return {
        ...state,
        async: {
          ...state.async,
          metadata: []
        }
      };
    case 'SHIPMENT_LOG_ASYNC_METADATA_SUCCESS':
      return {
        ...state,
        async: {
          ...state.async,
          metadata: action.data
        }
      };
    case 'SHIPMENT_LOG_ASYNC_METADATA_FAILURE':
      return {
        ...state,
        async: {
          ...state.async,
          metadata: []
        }
      };
    default:
      return state;
  }
};

const billing = (state = initialState.billing, action) => {
  switch (action.type) {
    case 'BILLING_REQUEST':
      return {
        ...state,
        list: [],
        isFetching: true,
        error: false
      };
    case 'BILLING_SUCCESS':
      return {
        ...state,
        list: action.data.list,
        filter: {
          ...state.filter,
          serviceType: action.data.serviceType,
          months: action.data.months
        },
        isFetching: false,
        error: false
      };
    case 'BILLING_FAILURE':
      return {
        ...state,
        list: [],
        isFetching: false,
        error: true
      };
    case 'BILLING_META_DATA_REQUEST':
    case 'BILLING_META_DATA_FAILURE':
      return {
        ...state,
        filter: {
          ...state.filter,
          billingType: []
        }
      };
    case 'BILLING_META_DATA_SUCCESS':
      return {
        ...state,
        filter: {
          ...state.filter,
          billingType: action.data
        }
      };
    case 'BILLING_SERVICE_META_DATA_REQUEST':
    case 'BILLING_SERVICE_META_DATA_FAILURE':
      return {
        ...state,
        filter: {
          ...state.filter,
          serviceType: []
        }
      };
    case 'BILLING_SERVICE_META_DATA_SUCCESS':
      return {
        ...state,
        filter: {
          ...state.filter,
          serviceType: action.data
        }
      };
    case 'BILLING_RULE_META_DATA_REQUEST':
    case 'BILLING_RULE_META_DATA_FAILURE':
      return {
        ...state,
        filter: {
          ...state.filter,
          ruleType: []
        }
      };
    case 'BILLING_RULE_META_DATA_SUCCESS':
      return {
        ...state,
        filter: {
          ...state.filter,
          ruleType: action.data
        }
      };
    case 'BILLING_DATA_REQUEST':
    case 'BILLING_DATA_FAILURE':
      return {
        ...state
      };
    case 'BILLING_DATA_SUCCESS':
      return {
        ...state
      };
    case 'BILLING_FETCH_DATA_REQUEST':
    case 'BILLING_FETCH_DATA_FAILURE':
      return {
        ...state
      };
    case 'BILLING_FETCH_DATA_SUCCESS':
      return {
        ...state,
        rule: {
          ...state.rule,
          list: action.data,
          isFetching: false
        }
      };
    default:
      return state;
  }
};

const trackingDelay = (state = initialState.trackingDelay, action) => {
  switch (action.type) {
    case 'TRACKING_DELAY_REQUEST':
      return {
        ...state,
        list: [],
        legends: [],
        colors: [],
        isFetching: true,
        error: false
      };
    case 'TRACKING_DELAY_SUCCESS':
      return {
        ...state,
        list: action.data.list,
        legends: action.data.legends,
        colors: action.data.colors,
        isFetching: false,
        error: false
      };
    case 'TRACKING_DELAY_FAILURE':
      return {
        ...state,
        list: [],
        isFetching: false,
        error: true
      };
    case 'TRACKING_DELAY_PERCENTILE_REQUEST':
      return {
        ...state,
        percentile: {
          ...state.percentile,
          list: [],
          legends: [],
          colors: [],
          isFetching: true,
          error: false
        }
      };
    case 'TRACKING_DELAY_PERCENTILE_SUCCESS':
      return {
        ...state,
        percentile: {
          ...state.percentile,
          list: action.data.list,
          legends: action.data.legends,
          colors: action.data.colors,
          isFetching: false,
          error: false
        }
      };
    case 'TRACKING_DELAY_PERCENTILE_FAILURE':
      return {
        ...state,
        percentile: {
          ...state.percentile,
          list: [],
          legends: [],
          colors: [],
          isFetching: false,
          error: true
        }
      };
    default:
      return state;
  }
};

const warehouse = (state = initialState.warehouse, action) => {
  switch (action.type) {
    case 'WAREHOUSE_REQUEST':
      return {
        ...state,
        cities: [],
        unmapped: [],
        isFetching: true,
        error: false
      };
    case 'WAREHOUSE_SUCCESS':
      return {
        ...state,
        cities: action.data.cities,
        unmapped: action.data.unmapped,
        isFetching: false,
        error: false
      };
    case 'WAREHOUSE_FAILURE':
      return {
        ...state,
        cities: [],
        unmapped: [],
        isFetching: false,
        error: true
      };
    case 'WAREHOUSE_UPDATE_SUCCESS':
      return {
        ...state,
        unmapped: action.data.unmapped
      };
    default:
      return state;
  }
};

const orderCreation = (state = initialState.orderCreation, action) => {
  switch (action.type) {
    case 'ORDER_CREATION_REQUEST':
      return {
        ...state,
        list: [],
        legends: [],
        colors: [],
        isFetching: true,
        error: false
      };
    case 'ORDER_CREATION_SUCCESS':
      return {
        ...state,
        list: action.data.list,
        legends: action.data.legends,
        colors: action.data.colors,
        isFetching: false,
        error: false
      };
    case 'ORDER_CREATION_FAILURE':
      return {
        ...state,
        list: [],
        isFetching: false,
        error: true
      };
    case 'ORDER_CREATION_CHANGE':
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
};

const featureEnvs = (
  state = initialState.featureEnvs || {
    loading: false,
    submitting: false,
    environments: [],
    error: null
  },
  action
) => {
  switch (action.type) {
    case 'FEATURE_ENVS_REQUEST':
      return {
        ...state,
        loading: true,
        submitting: false,
        error: null
      };
    case 'FEATURE_ENVS_SUCCESS': {
      const types = [
        'b2b',
        'b2c',
        'b2c_us',
        'prism',
        'returnsPlus',
        'trackingV2'
      ];
      const raw = Array.isArray(action.data) ? action.data : [];
      const flat = raw.map(item => {
        if (item.type && types.includes(item.type)) return item;
        for (let ti = 0; ti < types.length; ti += 1) {
          const t = types[ti];
          if ((state.environments[t] || []).some(e => e.link === item.link)) {
            return { ...item, type: t };
          }
        }
        return item;
      });
      const nextEnvs = {};
      types.forEach(t => {
        const fromApi = flat.filter(i => i.type === t);
        const apiLinks = new Set(fromApi.map(x => x.link));
        const stateLockedKeep = (state.environments[t] || []).filter(
          e => e.locked === true && !apiLinks.has(e.link)
        );
        nextEnvs[t] = [...stateLockedKeep, ...fromApi];
      });
      return {
        ...state,
        loading: false,
        submitting: false,
        environments: nextEnvs,
        error: null
      };
    }
    case 'FEATURE_ENVS_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error || 'Failed to fetch feature environments'
      };
    case 'FEATURE_ENVS_UPDATE_REQUEST':
      return {
        ...state,
        submitting: true,
        error: null
      };
    case 'FEATURE_ENVS_UPDATE_SUCCESS': {
      const rawFlat = (action.data && action.data.environments) || [];
      const types = [
        'b2b',
        'b2c',
        'b2c_us',
        'prism',
        'returnsPlus',
        'trackingV2'
      ];
      const flat = rawFlat.map(item => {
        if (item.type && types.includes(item.type)) return item;
        if (item.locked) {
          for (let ti = 0; ti < types.length; ti += 1) {
            const t = types[ti];
            if ((state.environments[t] || []).some(e => e.link === item.link)) {
              return { ...item, type: t };
            }
          }
        }
        return item;
      });
      const nextEnvs = {};
      types.forEach(t => {
        const fromApi = flat.filter(i => i.type === t);
        const apiLinks = new Set(fromApi.map(x => x.link));
        const stateLockedKeep = (state.environments[t] || []).filter(
          e => e.locked === true && !apiLinks.has(e.link)
        );
        nextEnvs[t] = [...stateLockedKeep, ...fromApi];
      });
      return {
        ...state,
        submitting: false,
        environments: nextEnvs,
        error: null
      };
    }
    case 'FEATURE_ENVS_UPDATE_FAILURE':
      return {
        ...state,
        submitting: false,
        error: action.error || 'Failed to save feature environments'
      };
    case 'FEATURE_ENVS_UPDATE':
      return {
        ...state,
        environments: action.data || [],
        error: null
      };
    default:
      return state;
  }
};

const session = combineReducers({
  user,
  metadata,
  alert,
  statuses,
  config,
  jobs,
  activeReports,
  shippingLabels,
  shipmentLog,
  billing,
  trackingDelay,
  warehouse,
  orderCreation,
  sampleTemplates,
  emailTemplate,
  featureEnvs
});

export default session;

// SELECTORS
// ================================================
export const selectCurrentUser = state => {
  return state.session.user;
};
